export default __webpack_public_path__ + "static/media/magic.d7898e1c.jpg";